import { ICellRenderer, ICellRendererParams } from 'ag-grid-community';

/**
 * Shared ag-Grid tree cell renderer behaviour: builds the indented, clickable
 * cell element and forwards node clicks to the parent grid component.
 *
 * Subclasses own the icon markup (`renderFolderFileCell` / `renderLoadingCell`)
 * and the column auto-size call, which differ per ag-Grid version in use.
 */
export abstract class BaseTreeCellRenderer implements ICellRenderer {
  public params: any;
  public eGui!: HTMLElement;
  public eventListener: any;
  public isLoading = false;

  public init(params: any): void {
    this.params = params;
    this.eGui = document.createElement('div');
    this.params.renderer.setStyle(
      this.eGui,
      'padding-left',
      `${params.data.level}px`,
    );
    this.params.renderer.setStyle(this.eGui, 'cursor', 'pointer');

    if (!params.data.isFile) {
      this.renderFolderFileCell(params);
      this.eventListener = () => {
        this.isLoading = true;
        this.renderLoadingCell(params);
        this.updateData(params.data.customId);
      };
      this.eGui.addEventListener('click', this.eventListener);
    } else {
      this.eGui.innerHTML = '';
    }

    this.autoSizeColumns(params);
  }

  /** Render the collapsed/expanded folder markup into `eGui`. */
  public abstract renderFolderFileCell(params: any): void;

  /** Render the "expanding" markup shown while children are being fetched. */
  protected abstract renderLoadingCell(params: any): void;

  /** Ask the grid to re-measure columns after the cell content changed. */
  protected abstract autoSizeColumns(params: any): void;

  public updateData(customId: number): void {
    this.params.context.componentParent.onNodeClick(customId);
  }

  public getGui(): HTMLElement {
    return this.eGui;
  }

  public refresh(params?: ICellRendererParams): boolean {
    return true;
  }

  public destroy(): void {
    if (this.eGui && this.eventListener) {
      this.eGui.removeEventListener('click', this.eventListener);
    }
  }

  public formatValue(value: string): string {
    if (value) {
      return value.replace(/^.*?=/, '');
    }
    return '';
  }
}
